import { z } from 'zod';

export const FormSchema = z.object({
  code: z.string().nonempty('Bạn chưa nhập mã tài khoản'),
  name: z.string().nonempty('Bạn chưa nhập tên tài khoản'),
  parent_account_code: z.string().optional(),
  tk_so_cai: z.boolean().optional(),
  tk_chi_tiet: z.boolean().optional(),
  bac_tk: z.number().optional(),
  currency_code: z.string().optional(),
  ar_ap_tracking_type: z.number().optional(),
  account_type_code: z.string().optional(),
  fx_reval_debit_type: z.number().optional(),
  fx_reval_credit_type: z.number().optional(),
  account_name_2: z.string().optional(),
  account_name_3: z.string().optional(),
  short_name_1: z.string().optional(),
  short_name_2: z.string().optional(),
  notes: z.string().optional(),
  active: z.boolean().default(true),
  balance_type: z.string().optional(),
  role: z.string().default('in_other')
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  code: '',
  name: '',
  parent_account_code: '',
  tk_so_cai: false,
  tk_chi_tiet: false,
  bac_tk: 0,
  currency_code: '',
  ar_ap_tracking_type: 0,
  account_type_code: 'KPL',
  fx_reval_debit_type: 0,
  fx_reval_credit_type: 0,
  account_name_2: '',
  account_name_3: '',
  short_name_1: '',
  short_name_2: '',
  notes: '',
  active: true,
  balance_type: 'debit',
  role: 'in_other'
};
